<template>
    <svg class="svg-icon" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M6.83302 11.8321C6.60986 12.0553 6.24805 12.0553 6.02489 11.8321C5.81348 11.6207 5.80236 11.2849 5.99151 11.0604L6.02489 11.024L9.04958 7.9997L6.02538 4.97549C5.81397 4.76407 5.80284 4.42822 5.992 4.20371L6.02538 4.16736C6.23679 3.95595 6.57264 3.94482 6.79715 4.13398L6.8335 4.16736L10.2616 7.59545C10.473 7.80686 10.4841 8.14271 10.295 8.36723L10.2616 8.40357L6.83302 11.8321Z"
            fill="white"
        />
    </svg>
</template>
